import { render, staticRenderFns } from "./QGISIntro.vue?vue&type=template&id=3e790b34&scoped=true&"
import script from "./QGISIntro.vue?vue&type=script&lang=js&"
export * from "./QGISIntro.vue?vue&type=script&lang=js&"
import style0 from "./QGISIntro.vue?vue&type=style&index=0&id=3e790b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e790b34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VIcon})
